import type { InvoiceOrBillStatus } from "@shop-ledger/shared-types";
import { apiRequest } from "../lib/apiClient";
// `InvoiceOrBillCreate`/`Out` come from the local `./types` (not `@shop-ledger/shared-types`)
// — the shared-types versions are stale and lack `customer_id`, which the backend added
// 2026-07-13 (§10.3). See `api/types.ts`'s file-level doc comment.
import type { InvoiceOrBillCreate, InvoiceOrBillOut } from "./types";

export async function listInvoices(accessToken: string, statusFilter?: InvoiceOrBillStatus): Promise<InvoiceOrBillOut[]> {
  return apiRequest<InvoiceOrBillOut[]>("/invoices", { accessToken, query: { status_filter: statusFilter } });
}

export async function createInvoice(accessToken: string, body: InvoiceOrBillCreate): Promise<InvoiceOrBillOut> {
  return apiRequest<InvoiceOrBillOut>("/invoices", { method: "POST", accessToken, body });
}
